// components/InstallPWAButton/InstallPWAButton.jsx
import React, { useState, useEffect } from "react";
import SloganCard from "../Layout/SloganCard";
import "./InstallPWAButton.css";

const InstallPWAButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isInstalling, setIsInstalling] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // تشخیص موبایل
    const checkMobile = () => {
      const mobileRegex =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      setIsMobile(mobileRegex.test(navigator.userAgent));
    };

    // بررسی نصب بودن با چند روش
    const checkStandalone = () => {
      setIsStandalone(
        window.matchMedia("(display-mode: standalone)").matches,
      );
    };

    checkMobile();
    checkStandalone();

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    const handleAppInstalled = () => {
      setIsInstallable(false);
      setIsInstalling(false);
      setIsStandalone(true);
      setDeferredPrompt(null);
    };

    const mediaQuery = window.matchMedia("(display-mode: standalone)");
    const handleDisplayModeChange = (e) => {
      if (e.matches) setIsStandalone(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);
    mediaQuery.addEventListener("change", handleDisplayModeChange);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
      window.removeEventListener("appinstalled", handleAppInstalled);
      mediaQuery.removeEventListener("change", handleDisplayModeChange);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt || isInstalling) return;

    setIsInstalling(true);

    try {
      await deferredPrompt.prompt();

      const timeoutPromise = new Promise((resolve) => {
        setTimeout(() => resolve({ outcome: "dismissed" }), 30000);
      });

      const userChoice = await Promise.race([
        deferredPrompt.userChoice,
        timeoutPromise,
      ]);

      if (userChoice.outcome === "accepted") {
        setIsInstallable(false);
        setIsStandalone(true);
        setDeferredPrompt(null);
      }
    } catch (error) {
      console.error("خطا در نصب PWA:", error);
    } finally {
      setIsInstalling(false);
    }
  };

  // منطق نمایش:
  // دسکتاپ: همیشه SloganCard
  // موبایل نصب نشده: دکمه نصب
  // موبایل نصب شده: SloganCard

  if (!isMobile || isStandalone) {
    // دسکتاپ یا موبایل با برنامه نصب شده
    return <SloganCard />;
  }

  // موبایل بدون برنامه نصب شده
  if (!isInstallable) return null;

  return (
    <button
      className={`install-pwa-btn ${isInstalling ? "installing" : ""}`}
      onClick={handleInstallClick}
      disabled={isInstalling}
    >
      <i
        className={`fas ${isInstalling ? "fa-spinner fa-spin" : "fa-download"}`}
      ></i>
      <span>{isInstalling ? "در حال نصب..." : "نصب برنامه"}</span>
    </button>
  );
};

export default InstallPWAButton;
